export function getAllGroupings(axiosPrivate) {
  return axiosPrivate.get('/groupings')
}

export function getGroupingOptions(axiosPrivate) {
  return axiosPrivate.get('/groupings/options')
}

export function getGroupingById(axiosPrivate, id) {
  return axiosPrivate.get(`/groupings/${id}`)
}

export function createGrouping(axiosPrivate, data) {
  return axiosPrivate.post('/groupings', data)
}

export function updateGroupingById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/groupings/${id}`, data)
}

export function deleteGrouping(axiosPrivate, id) {
  return axiosPrivate.delete(`/groupings/${id}`)
}
